export enum CommonConstants {
  USER_KEY = "user",
  USER_TOKEN = "token"
}

export const IMAGE_COMPRESSION_OPTIONS = {
  maxSizeMB: 10,
  maxWidthOrHeight: 1920,
  useWebWorker: true
};

export const APP_LINKS = {
  LOGIN: "/signin"
}

export const COMMUNITY_JUST_CREATED_KEY = "community_just_created";

export const STRIPE_CONNECT_RETURN_PATH_KEY = "stripe_connect_return_path";

export const INVITE_CONFIG_PARAM_KEY = "jn_cng";
export const INVITED_EMAIL_PARAM_KEY = "e";
export const POWERED_BY_GROUAPP_LINK = "https://www.group.app/?utm_source=GroupApp+communities&utm_medium=Log+in+screen&utm_campaign=Powered+by+GroupApp+log+in"

export const BYTES_IN_MB = 1000000;